import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const routes = [
   /* {
     path: '/',
     component: () => import('@/views/login'),
   }, {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login'),
  }, */
  {
    path: '/layout',
    name: 'login',
    redirect: '/layout/goods',
    component: ()=>import('@/views/layout'),
    children:[
      /* {
        path:'/layout/shangxiaxun',
        component: ()=>import('@/views/allvue/shangxiaxun'),
      }, */

      /* {
        path:'/layout/cannotJump',
        component: ()=>import('@/views/allvue/cannotJump'),
      }, */
      {
        path:'/layout/shangjia',
        component: ()=>import('@/views/allvue/shangjia'),
      },
      {
        path:'/layout/xiajia',
        component: ()=>import('@/views/allvue/xiajia'),
      },
      /* {
        path:'/layout/xunhuan',
        component: ()=>import('@/views/allvue/xunhuan'),
      },
      {
        path:'/layout/dianPshouQ',
        component: ()=>import('@/views/allvue/shouquan'),
      }, */
      {
        path:'/layout/goods',
        component: ()=>import('@/views/allvue/goods'),
      },
      {
        path:'/layout/goodsExport',
        component: ()=>import('@/views/allvue/goodsExport'),
      },
      {
        path:'/layout/goodscontrol1',
        component: ()=>import('@/views/allvue/goodscontrol1'),
      },
      {
        path:'/layout/goodscontrol2',
        component: ()=>import('@/views/allvue/goodscontrol2'),
      },
      {
        path:'/layout/goodscontrol3',
        component: ()=>import('@/views/allvue/goodscontrol3'),
      },
      /* {
        path:'/layout/goodscontrol',
        component: ()=>import('@/views/allvue/goodscontrol'),
      }, */
      {
        path:'/layout/chongfu',
        component: ()=>import('@/views/allvue/chongfu'),
      },
      {
        path:'/layout/diagnosis',
        component: ()=>import('@/views/allvue/diagnosis'),
      },
      {
        path:'/layout/jiance',
        component: ()=>import('@/views/allvue/jiance'),
      },
      {
        path:'/layout/jiance_sku',
        component: ()=>import('@/views/allvue/jianceSku'),
      },
      {
        path:'/layout/zhizhao',
        component: ()=>import('@/views/allvue/zhizhao'),
      },
      {
        path:'/layout/del_goods',
        component: ()=>import('@/views/allvue/delGoods'),
      },
      {
        path:'/layout/del_warn_goods',
        component: ()=>import('@/views/allvue/delWarnGoods'),
      },
      {
        path:'/layout/changeCate',
        component: ()=>import('@/views/allvue/changeCate'),
      },
      {
        path:'/layout/copygoods',
        component: ()=>import('@/views/allvue/copygoods'),
      },
      /* {
        path:'/layout/tuanduiZZhan',
        component: ()=>import('@/views/allvue/kdby'),
      }, */
      {
        path:'/layout/zicha',
        component: ()=>import('@/views/allvue/zicha'),
      },{
        path:'/layout/feiqi_cate',
        component: ()=>import('@/views/allvue/feiqiCate'),
      },
      /* {
        path:'/layout/shanghuo',
        component: ()=>import('@/views/allvue/shanghuo'),
      }, */
      {
        path:'/layout/logs',
        component: ()=>import('@/views/allvue/logs'),
      },
      /* {
        path:'/layout/GnqxModelAuth',
        component: ()=>import('@/views/allvue/setModelAuth'),
      },
      {
        path:'/layout/serviceMarketList',
        component: ()=>import('@/views/allvue/serviceMarketList'),
      } */
    ]
  },
  {
    path:'*',
    redirect: {
      name: 'login'
    }
  }
];
const router = new Router({
  mode:'history',
  routes,
});
export default router;
// })



// WEBPACK FOOTER //
// ./src/router/index.js